import * as React from 'react'
import { styled, css } from 'next-yak'

import * as S from '../../../styles'

const DefaultRadiomark = styled(S.radio.Radiomark).attrs({ $size: 18, $status: undefined })`
  display: inline-block;
`

const CheckedRadiomark = styled(S.radio.Radiomark).attrs({ $size: 18, $status: 'checked' })`
  display: none;
`

const FocusedRadiomark = styled(S.radio.Radiomark).attrs({ $size: 18, $status: 'focused' })`
  display: none;
`

export const ControlledRadioInputWrapper = styled.div`
  width: 18px;
  height: 18px;
`

type ControlledRadioInputProps = {
  className?: string
  disabled?: boolean
  children?: React.ReactNode // TODO: is it needed anymore ?
}

function ControlledRadioInputComponent({
  className,
  disabled,
  children,
}: ControlledRadioInputProps): React.ReactElement<ControlledRadioInputProps> {
  return (
    <ControlledRadioInputWrapper className={className}>
      {children}
      <DefaultRadiomark $disabled={disabled} />
      <FocusedRadiomark $disabled={disabled} />
      <CheckedRadiomark $disabled={disabled} />
    </ControlledRadioInputWrapper>
  )
}

export const ControlledRadioInput = styled(ControlledRadioInputComponent)``

const Container = styled.div`
  // yak does not give a class to non exported styled-component with no css.
  // this is an issue because this component is used as a selector later in the file
  // to fix this we need to add a bogus css rule to force yak to generate a class
  // see : https://github.com/DigitecGalaxus/next-yak/issues/373
  --bogus-style: 0;
`

export const focusedRadioCheck = css`
  ${FocusedRadiomark} {
    display: inline-block;
  }

  ${DefaultRadiomark}, ${CheckedRadiomark} {
    display: none;
  }
`

export const checkedRadioCheck = css`
  ${CheckedRadiomark} {
    display: inline-block;
  }

  ${DefaultRadiomark}, ${FocusedRadiomark} {
    display: none;
  }
`

const RadioInputWrapper = styled.div`
  ${S.input.HiddenFocusableInput}:focus + ${Container} {
    ${focusedRadioCheck}
  }

  ${S.input.HiddenFocusableInput}:checked + ${Container} {
    ${checkedRadioCheck}
  }
`

export type RadioInputComponentProps = {
  className?: string
  disabled?: boolean
} & React.InputHTMLAttributes<HTMLInputElement>

/** will forward any other props to the underlying `<input>` */
function RadioInputComponent({
  className,
  ...inputProps
}: RadioInputComponentProps): React.ReactElement<RadioInputComponentProps> {
  return (
    <RadioInputWrapper className={className}>
      <S.input.HiddenFocusableInput type="checkbox" {...inputProps} />
      <Container>
        <ControlledRadioInput disabled={inputProps.disabled} />
      </Container>
    </RadioInputWrapper>
  )
}

export const RadioInput = styled(RadioInputComponent)<RadioInputComponentProps>``
RadioInput.displayName = 'RadioInput'
